/* MYPOPMEE_MOBILE_FLOW_20261023 — présentation uniquement.
   Réordonne les NOEUDS existants de la fiche thématique ; aucun clone, aucun clic
   simulé, aucun événement ni attribut de commande/générateur modifié.
   Original restauré au passage desktop. */
(function(){
  'use strict';
  var root=document.getElementById('ppThemeSelector');
  var form=root && root.closest('form.pp-form');
  var style=document.getElementById('ppStyleSelector');
  var looks=root && root.querySelector('#ppThemeLooks');
  if(!root||!form||!style||!looks||!window.matchMedia)return;

  var mq=window.matchMedia('(max-width:749px)');
  var summary=root.querySelector('#ppThemeSelected');
  var title=root.querySelector('.pp-option-title');
  var grid=root.querySelector('.pp-theme-options');
  if(!title||!grid||!summary)return;
  var groups=Array.prototype.filter.call(form.children,function(el){
    return el.classList && el.classList.contains('pp-option-group');
  });
  var movable=[summary,style].concat(groups);
  var anchors=movable.map(function(el){
    var marker=document.createComment('mpm-flow-original-position');
    el.parentNode.insertBefore(marker,el);
    return {el:el,marker:marker};
  });
  var lang=(document.documentElement.lang||'fr').slice(0,2);
  var i18n={
    fr:['Modifier l’univers','Fermer les univers'],
    en:['Change theme','Close themes'],
    de:['Thema ändern','Themen schließen'],
    es:['Cambiar tema','Cerrar temas'],
    it:['Cambia tema','Chiudi temi'],
    nl:['Thema wijzigen','Thema’s sluiten']
  };
  var words=i18n[lang]||i18n.fr;
  var change=document.createElement('button');
  change.type='button';change.className='mx-flow-change';
  change.hidden=true;
  change.setAttribute('aria-controls','mx-universe-choice');
  grid.id='mx-universe-choice';
  title.appendChild(change);
  var mounted=false;

  function chosen(){return !!grid.querySelector('.pp-theme-option.active');}
  function update(){
    if(!mounted)return;
    var hasChoice=chosen();
    root.classList.toggle('mx-universe-chosen',hasChoice);
    if(!hasChoice)root.classList.add('mx-universe-editing');
    change.hidden=!hasChoice;
    var expanded=root.classList.contains('mx-universe-editing');
    change.textContent=expanded?words[1]:words[0];
    change.setAttribute('aria-expanded',expanded?'true':'false');
  }
  function mount(){
    if(mounted)return;
    root.insertBefore(summary,root.querySelector('.pp-theme-intro'));
    root.insertBefore(style,looks);
    groups.forEach(function(el){root.insertBefore(el,looks);});
    mounted=true;
    root.classList.add('mx-mobile-flow');
    root.classList.remove('mx-universe-editing');
    update();
  }
  function unmount(){
    if(!mounted)return;
    anchors.forEach(function(item){
      if(item.marker.parentNode)item.marker.parentNode.insertBefore(item.el,item.marker.nextSibling);
    });
    mounted=false;
    change.hidden=true;
    root.classList.remove('mx-mobile-flow','mx-universe-chosen','mx-universe-editing');
  }
  function responsive(){if(mq.matches)mount();else unmount();}
  change.addEventListener('click',function(){
    if(!mounted)return;
    root.classList.toggle('mx-universe-editing');
    update();
    if(root.classList.contains('mx-universe-editing')){
      var y=grid.getBoundingClientRect().top+window.pageYOffset-90;
      window.scrollTo({top:Math.max(0,y),behavior:'smooth'});
    }
  });
  document.addEventListener('pp:theme-change',function(){
    if(!mounted)return;
    root.classList.remove('mx-universe-editing');
    setTimeout(update,0);
  });
  if(mq.addEventListener)mq.addEventListener('change',responsive);
  else if(mq.addListener)mq.addListener(responsive);
  responsive();
})();